module.exports = __webpack_public_path__ + "img/neckline length.4689ba56.png";